import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Button, TextField, Card, Typography } from '@material-ui/core';
import LinearProgress from '@material-ui/core/LinearProgress';
import { Formik } from 'formik';
import { string, object } from 'yup';
import { FilePond, registerPlugin } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import {
  addPodcastRequest,
  editPodcastRequest,
} from 'features/AddPodcast/addPodcastSlice';
import { imgBaseURL } from '../../apis/Admin';

registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateType
);
function Alert(props) {
  return (
    <>
      <MuiAlert elevation={6} variant="filled" {...props} />
    </>
  );
}
const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  table: {
    minWidth: 1000,
  },
  container: {
    margin: '1rem',
  },
  filter: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    padding: '1rem',
  },
  pagination: {
    marginLeft: 'auto',
    margincenter: 'auto',
    marginBottom: '60px',
  },
  cardBackground: {
    border: '1px solid',
    padding: '10px',
    //boxShadow: "5px 10px 10px #1f1a3c",
  },
  center: {
    textAlign: 'center',
  },
  imgReq: {
    textAlign: 'start',
    paddingLeft: '15px',
    fontSize: '12px',
    color: '#f44336',
  },
  formStyle: {
    width: '50%',
    textAlign: 'center',
    margin: 'auto',
  },
  paddingTop: {
    paddingTop: '20px',
  },
  buttonSubmit: {
    marginBottom: "20px",
    marginTop: "20px", 
    background: '#45b77c',
    fontFamily: 'sans-serif !important',
    transition: 'background 0.3s ease',
    '&:hover': {
      background: '#358c5e',
    },
  },
  imgWidth: {
    width: '150px',
  },
  heading: {
    color: "#45b77c",
  },
});

const AddPodcast = ({ currentId, editData, setShowEditImg, showEditBtn }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [imgFiles, setImgFiles] = useState(null);
  const [showPreBtn, setShowPreBtn] = useState(false);
  const [showImgFile, setShowImgFile] = useState(currentId ? false : true);
  const imgUrl = imgBaseURL;
  const [editImgUrl] = useState(`${imgUrl}/${editData.image}`);

  const validationSchema = object().shape({
    description: string().required('Required'),
    title: string().required('Required'),
    spotifyLink: string().url('Invalid url').required('Required'),
    appleLink: string().url('Invalid url').required('Required'),
  });

  const loading = useSelector(state => state.addPodcast.loading);
  const responseMessage = useSelector(state => state.addPodcast.message);

  console.log(imgFiles, 'imgFiles');
  const initialValues = {
    description: currentId ? editData.description : '',
    title: currentId ? editData.title : '',
    spotifyLink: currentId ? editData.spotifyLink : '',
    appleLink: currentId ? editData.appleMusicLink : '',
  };
  const submitPodcast = (values, { resetForm }) => {
    if (imgFiles === null) {
      setShow(true);
    }
    const formData = new FormData();
    if (currentId) {
      formData.append('id', currentId);
    }
    if (imgFiles) {
      formData.append('image', imgFiles[0].file);
    } else {
      formData.append('image', editData.image);
    }
    formData.append('description', values.description);
    formData.append('title', values.title);
    formData.append('spotifyLink', values.spotifyLink);
    formData.append('appleMusicLink', values.appleLink);
    if (currentId) {
      dispatch(editPodcastRequest(formData));
    } else {
      dispatch(addPodcastRequest(formData));
    }

    resetForm();
    setImgFiles(null);
    setOpen(true);
  };
  const handleClose = (reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  const editImage = () => {
    setShowEditImg(false);
    setShowPreBtn(true);
    setShowImgFile(true);
  };
  const preImage = () => {
    setShowEditImg(true);
    setShowPreBtn(false);
    setShowImgFile(false);
  };
  return (
    <>
      <div className={classes.root}>
        <Grid container spacing={3} className={classes.center}>
          <Grid item xs={12}>
            <Typography variant="h4" component="h4" className={classes.heading}>
              Add Podcast
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Card className={classes.cardBackground}>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={submitPodcast}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit
                }) => (
                  <form onSubmit={handleSubmit} className={classes.formStyle}>
                    <div className={classes.paddingTop}>
                      <Grid item xs={12} className={classes.paddingTop}>
                        {showImgFile && (
                          <FilePond
                            files={imgFiles}
                            allowReorder={true}
                            allowMultiple={false}
                            acceptedFileTypes={['image/jpeg', 'image/png']}
                            onupdatefiles={setImgFiles}
                            labelIdle='Drag & Drop only images or <span class="filepond--label-action">Browse</span>'
                            credits={false}
                          />
                        )}
                        {showEditBtn &&
                          currentId &&
                          (imgFiles === null ? (
                            <img
                              src={editImgUrl}
                              alt="imgFile"
                              className={classes.imgWidth}
                            />
                          ) : (
                            ''
                          ))}
                        {!currentId && (
                          <div className={classes.imgReq}>
                            {show
                              ? imgFiles === null && <span>Required</span>
                              : ''}
                          </div>
                        )}
                      </Grid>
                      <Grid item xs={12}>
                        {showEditBtn && (
                          <Button onClick={editImage}>Edit Image</Button>
                        )}
                      </Grid>
                      <Grid item xs={12}>
                        {showPreBtn && (
                          <Button onClick={preImage}>Previous Image</Button>
                        )}
                      </Grid>
                      <Grid item xs={12} className={classes.paddingTop}>
                        <TextField
                          label="Title"
                          type="text"
                          variant="outlined"
                          name="title"
                          id="formTitle"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.title}
                          helperText={touched.title ? errors.title : false}
                          error={touched.title && !!errors.title}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12} className={classes.paddingTop}>
                        <TextField
                          label="Description"
                          type="text"
                          variant="outlined"
                          name="description"
                          id="formDescription"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.description}
                          helperText={
                            touched.description ? errors.description : false
                          }
                          error={touched.description && !!errors.description}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12} className={classes.paddingTop}>
                        <TextField
                          label="Spotify url"
                          type="url"
                          variant="outlined"
                          name="spotifyLink"
                          id="formSpotifyLink"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.spotifyLink}
                          helperText={
                            touched.spotifyLink ? errors.spotifyLink : false
                          }
                          error={touched.spotifyLink && !!errors.spotifyLink}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12} className={classes.paddingTop}>
                        <TextField
                          label="Apple url"
                          type="url"
                          variant="outlined"
                          name="appleLink"
                          id="formAppleLink"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.appleLink}
                          helperText={
                            touched.appleLink ? errors.appleLink : false
                          }
                          error={touched.appleLink && !!errors.appleLink}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.buttonSubmit}
                          onClick={handleSubmit}
                        >
                          Add Podcast
                        </Button>
                      </Grid>
                    </div>
                  </form>
                )}
              </Formik>
            </Card>
          </Grid>
        </Grid>
      </div>
      <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity={responseMessage === 'Failed' ? 'error' : 'success'}
        >
          <p className="message">{responseMessage}</p>
        </Alert>
      </Snackbar>
      {loading ? <LinearProgress className="loader" /> : false}
    </>
  );
};

export default AddPodcast;
